<template>
    <div id="org_settings_connections-view-dataset" class="mt-3 mb-5">
        <div id="org_settings_connections-view-dataset__text">
            <div class="d-flex flex-column gap-1 flex-grow-1">
                <div class="card-body">
                    <div class="system-connection-card__header row">
                        <div class="col-12 d-flex" v-if="local_connection">
                            <div class="system-connection-card__header__icon d-flex align-items-center mb-2">
                                <img :src="local_connection.integration.logo_url" :alt="local_connection.integration.name" class="avatar rounded-circle avatar-sm me-2 bg-white">
                            </div>
                            <h3 class="my-1">{{ local_connection.integration.display_name }}</h3>

                            <div class="system-connection-card__header__status mx-2 my-1">
                                <span class="badge badge-secondary d-inline-block" v-if="!local_connection.sync_error_msg && !local_connection.last_synced_at && !local_connection.initial_sync_at">Initializing</span>
                                <!-- <span class="badge badge-primary d-inline-block" v-else-if="local_connection.activeJobs.length >0">Syncing</span> -->
                                <span class="badge bg-red bg-icon-danger d-inline-block" v-else-if="local_connection.sync_error_msg" data-bs-toggle="tooltip" :title="local_connection.sync_error_msg">Error</span>
                                <span class="badge bg-gray bg-icon-progress d-inline-block" v-else-if="local_connection.active_jobs && local_connection.active_jobs.length > 0">Syncing</span>
                                <span class="badge bg-green bg-icon-success d-inline-block" v-else>Active</span>
                            </div>

                            <div class="system-connection-card__header__actions" v-if="(canSync() || canDelete()) && canEdit('connections')">
                                <button class="btn btn-white btn-icon-only-md" data-bs-toggle="dropdown" aria-expanded="false" aria-label="Actions">
                                    <img class="icon" src="/img/icons/avid-icons/vertical-dots.svg" data-bs-toggle="tooltip" title="Actions" alt="">
                                </button>

                                <ul class="dropdown-menu dropdown-menu-primary">
                                    <li><a class="dropdown-item" href="#" @click.prevent="updateConnection()">
                                        <img class="icon me-2" src="/img/icons/avid-icons/key.svg" alt="">Update Credentials</a>
                                    </li>

                                    <li v-if="canSync()"><a class="dropdown-item" href="#" @click.prevent="syncConnection()">
                                        <img class="icon me-2" src="/img/icons/avid-icons/sync.svg" alt="">Sync Now</a>
                                    </li>

                                    <li v-if="canDelete()"><a class="dropdown-item text-danger" href="#" @click.prevent="deleteConnection()">
                                        <img class="icon red-icon me-2" src="/img/icons/avid-icons/trash.svg" alt="">Delete</a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-12 d-flex" v-if="local_file">
                            <h3 class="mt-1">{{ local_file.name }}</h3>

                            <div class="system-connection-card__header__status ms-2">
                                <span class="badge bg-green bg-icon-success d-inline-block" v-if="local_file.status == 'ready'">Ready</span>
                                <span class="badge bg-red bg-icon-danger d-inline-block"  data-bs-toggle="tooltip" :title="local_file.status_msg" v-else>Error</span>
                           </div>

                            <div class="system-connection-card__header__actions" v-if="canEdit('connections')">
                                <button class="btn btn-none p-1" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false" aria-label="Actions">
                                    <img class="icon pe-0" src="/img/icons/avid-icons/vertical-dots.svg" data-bs-toggle="tooltip" title="Actions" alt="">
                                </button>
                                <ul class="dropdown-menu dropdown-menu-primary">
                                    <li v-if="isDataFile(local_file)"><a class="dropdown-item" href="#" @click="previewTable(local_file)" data-bs-toggle="modal" data-bs-target="#preview-modal">
                                        <img class="icon" src="/img/icons/avid-icons/eye.svg" alt=""> Preview File
                                    </a></li>

                                    <li v-if="withinThirtyDays(local_file) && canExport('connections')"><a class="dropdown-item" :href="'/integrations/'+ client.url +'/files/download/'+ local_file.id" target="_blank">
                                        <img class="icon" src="/img/icons/avid-icons/download.svg" alt=""> Download File
                                    </a></li>

                                    <li><a class="dropdown-item" href="#" target="_blank" @click="removeFile(local_file)">
                                        <img class="icon red-icon" src="/img/icons/avid-icons/trash.svg" alt=""> Delete File
                                    </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="system-connection-card__content">
                        <div class="d-flex flex-row align-items-center">
                            <div class="d-flex-flex-column">
                                <small v-if="local_connection && (local_connection.sync_error_msg || getLastSyncStatus(local_connection.id) === 'failed')"><em v-html="local_connection.sync_error_msg || getLastSyncErrorMessage(local_connection.id)"></em></small>
                                <small v-else-if="local_connection && local_connection.active_jobs?.length > 0">{{ local_connection.name }} &nbsp | &nbsp Started At: {{ datetime(local_connection.last_synced_at) }} | {{ number_with_zero(local_connection.active_jobs[0].rowsSynced) }} Rows Synced</small>
                                <small v-else-if="local_connection && local_connection.last_synced_at == null">{{ local_connection.name }} &nbsp | &nbsp Created on: {{ date(local_connection.created_at) }}</small>
                                <small v-else-if="local_connection">{{ local_connection.name }} &nbsp | &nbsp Last Synced: {{ date(local_connection.last_synced_at) }}  &nbsp | &nbsp  Created on: {{ date(local_connection.created_at) }}</small>
                                <small v-else>{{ local_file.source }} &nbsp | &nbsp Uploaded date: {{ date(local_file.created_at) }} </small>
                            </div>
                        </div>

                        <div class="alert border-danger border-primary mt-4 mb-4" v-if="local_connection && local_connection.sync_error_msg">
                            <div class="row">
                                <div class="col-12">
                                    <h4>Integration Error</h4>
                                    <p>Avid encountered an error with your {{local_connection.integration.display_name }} connection. To reactivate the integration, you simply need to click the button below and follow the steps listed.</p>
                                </div>
                                <div class="col-12 mt-3">
                                    <div v-if="!canEdit('connections')" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                                        <button class="btn btn-error" :disabled="true">
                                            <i class="fa fa-key text-danger"></i> Reconnect {{local_connection.integration.display_name }}
                                        </button>
                                    </div>
                                    <button v-else class="btn btn-error" @click.prevent="updateConnection()">
                                        <i class="fa fa-key text-danger"></i> Reconnect {{local_connection.integration.display_name }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="alert bg-secondary mt-3 mb-4" v-else-if="local_connection && local_connection.datasets && local_connection.datasets.length > 0">
                            <div class="row">
                                <div class="col-12">
                                    <h4>Can We Help?</h4>
                                    <p>Avid is built to be as flexible as you need it to be with the ability to customize how channels, appeals, and other critical pieces of information are defined. Unfortunately, with that flexibility comes complexity but we're here to help. Just let us know and we can help you get your data correctly mapped so Avid provides the maximum value.</p>
                                </div>
                                <div class="col-12 mt-3">
                                    <button class="btn btn-white" data-bs-toggle="modal" :data-bs-target="'#support-modal-'+selected_ticket_type" @click="openSupportModal()">
                                        <img class="icon pe-2" src="/img/icons/avid-icons/glasses.svg" alt=""> Help Me Set Up My Data (* this is a free service)
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="mt-3" v-if="local_datasets && local_datasets.length > 0">
                            <p class="mb-3">
                                A "data set" is a view of the data extracted from your integrated systems. Below you can add filters to these views to limit the data available for analysis 
                                and syncronization to third party systems. If you'd like more information about how this all works, please 
                                <a href="https://help.avidai.com/hc/en-us/articles/42928674866963-Integrations-Data-Sets-and-More" target="_blank">check out Avid's Knowledge Base.</a>
                            </p>
                            <nav v-if="local_datasets.length <=3" class="navbar navbar-expand secondary-tab-bar d-flex mb-3">
                                <div class="container-fluid">   
                                    <div class="collapse navbar-collapse">
                                        <ul class="navbar-nav">
                                            <li class="nav-item" v-for="(dataset, index) in local_datasets" :key="dataset.id">
                                                <a class="nav-link d-flex flex-nowrap secondary-tab" :class="{'secondary-tab-active': index == active_tab_index}"
                                                href="#" role="button" aria-expanded="false" @click.prevent="setActiveTab(index)">
                                                    <span>{{ propercase(dataset.name) }}</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>                                    
                                </div>
                            </nav>

                            <div class="col-12 mb-3 mt-3" v-else>
                                <label class="form-label">Select a Data Set to <span v-if="!canEdit('connections')">View</span><span v-else>Edit</span></label>
                                <select class="form-select" name="dataset-selection" v-model="active_tab_index" @change="changeDatasetSelection()" aria-label="Dataset Selection">
                                    <option :value="index" v-for="(dataset, index) in local_datasets" :key="dataset.id">{{dataset.name}}</option>
                                </select>
                            </div>

                            <div v-for="(dataset, index) in local_datasets" :key="dataset.id" :class="(index == active_tab_index ? '' : 'd-none')" class="row">
                                <div class="system-connection-card__header__status">
                                    <label class="form-label mb-0">Data Set Name </label>
                                    <span v-if="(local_connection && local_connection.integration && (local_connection.integration.name == 'FileUpload' || local_connection.integration.name == 'RemoteSFTP' || local_connection.integration.name == 'SFTP')) && local_files.length == 0 && local_datasets.length == 0"
                                    class="badge bg-red bg-icon-danger d-inline-block">
                                        <img class="info-icon" src="/img/icons/avid-icons/info.svg" data-bs-toggle="tooltip" title="There are no source files uploaded for this data set" alt=""></img>Inactive
                                    </span>
                                </div>
                                <div class="col-lg-9 col-12 mb-2">
                                    <h4 class="d-flex" v-if="!canEdit('connections') || !if_editing_dataset_name" style="vertical-align: middle; align-items: center;text-align: center;">
                                        {{ dataset.name }}
                                        <button v-if="canEdit('connections')" class="btn btn-none" @click.prevent="toggleEditName()" data-bs-toggle="tooltip" title="Edit Dataset Name">
                                            <img class="icon" src="/img/icons/avid-icons/edit.svg" alt="">
                                        </button>
                                        <div v-else class="d-inline-block" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                                            <button class="btn btn-none" :disabled="true">
                                                <img class="icon" src="/img/icons/avid-icons/edit.svg" alt="">
                                            </button>
                                        </div>
                                    </h4>

                                    <div v-else>
                                        <div class="d-flex flex-row gap-1">
                                            <input type="text" class="form-control" v-model="local_datasets[index].name" :class="((errors.name != '' )? 'is-invalid':'')" :disabled="!canEdit('connections')" aria-label="Name">
                                            <button :disabled="!canEdit('connections')" class="btn btn-primary reg-btn btn-icon-only-md" 
                                            @click.prevent="saveDataSetName(index)" data-bs-toggle="tooltip" title="Save Data Set Name">
                                                <img class="icon" src="/img/icons/avid-icons/save.svg" alt="">
                                            </button>
                                            <button :disabled="!canEdit('connections')" class="btn btn-secondary btn-icon-only-md" @click.prevent="cancelEditName(index)">
                                                <img class="icon m-0" src="/img/icons/avid-icons/close.svg" data-bs-toggle="tooltip" title="Cancel Editing" alt="">
                                            </button>
                                        </div>
                                        <div class="text-danger invalid-feedback" v-if="errors.name">
                                            {{errors.name}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-12 mb-1" v-if="dataset.source_type != 'other' || dataset.source_subtype != null">
                                    <div v-if="!canEdit('connections') && dataset.is_primary==0" data-bs-toggle="tooltip" 
                                        title="You do not have privileges to complete this action">
                                        <button class="btn btn-secondary float-end mb-2" :disabled="true">
                                            <img class="icon" src="/img/icons/avid-icons/1st-medal.svg" alt=""> Set As Primary Data Set
                                        </button>
                                    </div>
                                    <button v-else-if="dataset.is_primary==0" class="btn btn-secondary float-end mb-2"
                                        @click.prevent="updateIsPrimary(dataset)">
                                        <img class="icon" src="/img/icons/avid-icons/1st-medal.svg" alt=""> Set As Primary Data Set 
                                        <img class="info-icon" src="/img/icons/avid-icons/info.svg" data-bs-toggle="tooltip" title="Certain analyses require a single source to be used in the analysis. Setting the primary flag identifies which source to use." alt=""></img>
                                    </button>
                                    <span v-else class="float-end mt-2">
                                        <i class="fa fa-check fa-xl green"></i> Primary Data Set
                                        <img class="info-icon" src="/img/icons/avid-icons/info.svg" data-bs-toggle="tooltip" title="Certain analyses require a single source to be used in the analysis. Setting the primary flag identifies which source to use." alt=""></img>
                                    </span>
                                </div>

                                <div v-if="index == active_tab_index" class="col-12">
                                    <div class="d-flex flex-column justify-content-start gap-3 dataset-accordion">
                                        <div class="card accordion mb-0" key="dataset-file-information" v-if="file_or_connection == 'file' || isFileConnection()">
                                            <div class="accordion-item">
                                                <div class="accordion-header">
                                                    <button class="accordion-button" type="button"
                                                        :data-bs-target="'#dataset-file-information'" data-bs-toggle="collapse"
                                                        aria-expanded="false" :aria-controls="'dataset-file-information'"
                                                        :class="{ collapsed: active_accordion !== 'dataset-file-information' }"
                                                        @click="toggleAccordion('dataset-file-information')">
                                                        <h4 class="mb-0">Information</h4>
                                                    </button>
                                                </div>
                                                <div class="accordion-body accordion-collapse collapse pt-0" id="dataset-file-information" :class="active_accordion === 'dataset-file-information' ? 'show' : ''">
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <div class="mb-3">
                                                                <label class="form-label">Data Set Type</label>
                                                                <select class="form-select" v-model="dataset.source_type_id"
                                                                    @change="setDataSourceType(index)" :disabled="!canEdit('connections')" aria-label="Data Set Type">
                                                                    <option v-for="(cols, key) in source_types" :key="key" :value="key">{{ key }}</option>
                                                                </select>
                                                                <div class="alert bg-secondary mt-2" v-if="hasTypeChanged(dataset, index) && dataset.source_type_id && getCategoryDescription(dataset.source_type_id)">
                                                                    <p class="mb-2"><img class="icon me-2" src="/img/icons/avid-icons/info.svg" style="width: 20px;" alt=""></img>
                                                                    <strong>{{ dataset.source_type_id }}:</strong> {{ getCategoryDescription(dataset.source_type_id) }} </p>
                                                                    <p class="mb-0">For more information on these categories, see <a href="https://help.avidai.com/hc/en-us/articles/42928646830099--Add-a-Data-Set" target="_blank">Avid's Knowledge Base.</a></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-12 col-md-6">
                                                            <div v-if="dataset.source != 'Airbyte' && dataset.source != 'Table'">
                                                                <div class="mb-3">
                                                                    <label class="form-label">Refresh Type</label>
                                                                    <select class="form-select"  v-model="dataset.settings.refresh_type" @change="handleRefreshTypeChange()" :disabled="!canEdit('connections')" aria-label="Refresh Type">
                                                                        <option value="incremental" >Append: New files are merged with prior uploads</option>
                                                                        <option value="full" >Replace: New files replace prior uploads</option>
                                                                    </select>
                                                                    <em class="small" v-if="dataset.settings.refresh_type == 'incremental'">When appending files, the "Updated At" field will ensure the most recent record is used (if it is set on the Column Mapping screen).</em>

                                                                </div>
                                                                <div class="mb-3" v-if="dataset.settings.refresh_type == 'incremental'">
                                                                    <label class="form-label" data-bs-toggle="tooltip" title="When appending files, you can select one or more columns to be used as a unique ID. Records with the same ID as a record in a prior upload will be used as a replacement rather than a new record. If no columns are selected, records will always be appended.">Column(s) to Identify Unique Records <img class="info-icon" src="/img/icons/avid-icons/info.svg" alt=""></img></label>
                                                                    <div class="dropdown">
                                                                        <button class="btn form-select btn-field w-100" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" 
                                                                            aria-expanded="false" data-bs-auto-close="outside" :disabled="!canEdit('connections')">
                                                                            <span v-if="(dataset.settings.id_columns != null && dataset.settings.id_columns.length > 0 )">{{ id_columns }}</span><span v-else><em>None Selected</em></span>
                                                                        </button>
                                                                        <div class="dropdown-menu dropdown-menu-primary " style="max-height: 250px; overflow-y: auto;" aria-labelledby="dropdownMenuButton"  >
                                                                            <label class="dropdown-item" v-for="(item, key) in sortedSourceColumns" :key="key">
                                                                                <input class="form-check-input" type="checkbox" :value="key"  v-model="dataset.settings.id_columns" :true-value="[]" :disabled="!canEdit('connections')" aria-label="Id Columns">
                                                                                <span class="ms-2" >
                                                                                {{ item }}
                                                                                </span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="mb-3">
                                                                    <label class="form-label" data-bs-toggle="tooltip" title="Identify what files should be included in this data set. You can use a wildcard character (%) if there are parts of the file name that will change with each upload or, for more advanced rules, use a regular expression by starting the pattern with r' and ending it with a '">File Name Pattern <img class="info-icon" src="/img/icons/avid-icons/info.svg" alt=""></img></label>
                                                                    <input type="text" class="form-control" :class="((errors.pattern != '' )? 'is-invalid':'')"
                                                                        name="pattern" v-model="dataset.settings.pattern" @change="refreshFiles()" :disabled="!canEdit('connections')" aria-label="Pattern">
                                                                    <div class="text-danger invalid-feedback" v-if="errors.pattern != ''">
                                                                        {{errors.pattern}}
                                                                    </div>
                                                                </div>
                                                                <div class="mb-3">
                                                                    <div class="form-check">
                                                                    <input class="form-check-input" type="checkbox" id="ignore_unused" v-model="dataset.settings.ignore_unused" @change="columnsValid()" :disabled="!canEdit('connections')" aria-label="Ignore Unused">
                                                                    <label class="form-check-label" for="ignore_unused" :disabled="!canEdit('connections')">
                                                                        <strong>Ignore Unused Column Changes.</strong> If columns are added or removed in future uploads, the file will still process when the changes don't impact existing mappings.
                                                                    </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-md-6"  v-if="dataset.source != 'Airbyte' && dataset.source != 'Table'">
                                                            <div class="card mb-3 ms-2 overflow-hidden">
                                                                <div class="card-body px-0 pb-0">
                                                                    <p class="px-3 pb-2">Based upon the pattern specified, the following files will be included in this data set:</p>
                                                                    <div class="table-width-responsive" style="max-height: 271px;" v-if="local_files && local_files.length > 0">
                                                                        <table class="table gy-0 m-0 mb-2">
                                                                            <thead class="table-dark">
                                                                                <tr>
                                                                                    <th class='align-middle'>File Name</th>
                                                                                    <th class="align-middle" colspan="2">Uploaded At</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <transition-group tag="tbody" name="table-row" class="table-border-bottom-0" >
                                                                                <tr v-for="(f, index) in local_files" :key="f.id" :class="(f.status_msg == 'MISMATCH' ? 'error' : '')">
                                                                                    <td class='ps-3 align-middle'>
                                                                                        {{f.name}}
                                                                                    </td>
                                                                                    <td class="align-middle text-nowrap" :colspan="(f.status_msg == 'MISMATCH'? '1' : '2')" >{{ datetime(f.created_at) }}</td>
                                                                                    <td v-if="f.status_msg == 'MISMATCH'" class="text-end">
                                                                                        <button type="button" class="btn btn-sm btn-none red" data-bs-toggle="tooltip" title="Delete file">
                                                                                            <i class="fa fa-trash" @click="removeFile(f)"></i>
                                                                                        </button>
                                                                                    </td>
                                                                                </tr>
                                                                            </transition-group>
                                                                        </table>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p class="p-3"><strong><em>No files were found that match the given pattern.</em></strong></p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row" >
                                                        <div class="col">
                                                            <div class="alert alert-danger mb-3" v-if="information_form.error">
                                                                There is an issue with the information provided in the form above. Please check the fields and make the necessary corrections.
                                                            </div>
                                                            <!-- Save Button -->
                                                            <div>
                                                                <div v-if="!canEdit('connections')" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                                                                    <button type="submit" class="btn btn-primary" :disabled="true">
                                                                        <img class="icon me-1" src="/img/icons/avid-icons/save.svg" alt="">
                                                                    </button>
                                                                </div>
                                                                <button v-else type="submit" class="btn btn-primary" @click="saveInformation(dataset, index)" :disabled="information_form.busy">
                                                                    <div v-if="information_form.busy" class="spinner-border spinner-border-sm float-left ms-1" role="status"></div>
                                                                    <img class="icon me-1" src="/img/icons/avid-icons/save.svg" v-else alt=""> Save
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card accordion mb-0" key="dataset-inclusion-filters">
                                            <div class="accordion-item">
                                                <div class="accordion-header">
                                                    <button class="accordion-button" type="button"
                                                        :data-bs-target="'#dataset-inclusion-filters'" data-bs-toggle="collapse"
                                                        aria-expanded="false" :aria-controls="'dataset-inclusion-filters'"
                                                        :class="{ collapsed: active_accordion !== 'dataset-inclusion-filters' }"
                                                        @click="toggleAccordion('dataset-inclusion-filters')">
                                                        <h4 class="mb-0">Inclusion Filters</h4>
                                                    </button>
                                                </div>
                                                <div class="accordion-body accordion-collapse  collapse pt-0" id="dataset-inclusion-filters"
                                                    :class="active_accordion === 'dataset-inclusion-filters' ? 'show' : ''">
                                                    <div class="row">
                                                        <div class="col mb-4 ">
                                                            <!-- <h2>Inclusion Filters</h2> -->
                                                            <p>You are able to limit the records in your data set. This is helpful if removing records like soft credits from a list of transactions or non-donors from a list of constituents.</p>
                                                            <query-builder :client="client" v-model="dataset.filter" :id="'dataset-inclusion-filters-'+dataset.id" :key="dataset.id"
                                                                :static_db_columns="getSourceColumnsWithJoin(dataset)" :source="dataset.data_source"
                                                                :data_source_id="dataset.id" ref="filter" :if_allow_edit="canEdit('connections')"></query-builder>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col">
                                                            <div class="alert alert-danger mb-3" v-if="inclusion_filter_form.error">
                                                                There is an issue with the information provided in the fields above. Please check your entries and make the necessary corrections.
                                                            </div>

                                                            <!-- Refine and Save Buttons -->
                                                            <div class="d-flex gap-2">
                                                                <div v-if="!canEdit('connections')" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                                                                    <button type="button" class="btn btn-secondary" :disabled="true">
                                                                        <img class="icon me-1" src="/img/icons/avid-icons/edna.svg" alt="">Refine
                                                                    </button>
                                                                </div>
                                                                <button v-else type="button" class="btn btn-secondary" :class="{'is-generating': filterSuggestionDisabled[index], 'generating-background': filterSuggestionDisabled[index]}" @click="requestFilterSuggestion(dataset, index)" :disabled="filterSuggestionDisabled[index] || inclusion_filter_form.busy">
                                                                    <div v-if="filterSuggestionDisabled[index] || inclusion_filter_form.busy" class="spinner-border spinner-border-sm float-left ms-1" role="status"></div>
                                                                    <img v-else class="icon me-1" src="/img/icons/avid-icons/edna.svg" alt="">
                                                                    Refine
                                                                </button>
                                                                <div v-if="!canEdit('connections')" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                                                                    <button type="submit" class="btn btn-primary reg-btn ms-1" :disabled="true">
                                                                        <img class="icon me-1" src="/img/icons/avid-icons/save.svg" alt="">Save
                                                                    </button>
                                                                </div>
                                                                <button v-else type="submit" class="btn btn-primary reg-btn ms-1" @click="saveInclusionFilters(dataset, index)" :disabled="inclusion_filter_form.busy">
                                                                    <div v-if="inclusion_filter_form.busy" class="spinner-border spinner-border-sm float-left ms-1" role="status"></div>
                                                                    <img v-else class="icon me-1" src="/img/icons/avid-icons/save.svg" alt="" > Save
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card accordion mb-0" key="dataset-column-mappings">
                                            <div class="accordion-item">
                                                <div class="accordion-header">
                                                    <button class="accordion-button" type="button"
                                                        :data-bs-target="'#dataset-column-mappings'" data-bs-toggle="collapse"
                                                        aria-expanded="false" :aria-controls="'dataset-column-mappings'"
                                                        :class="{ collapsed: active_accordion !== 'dataset-column-mappings' }"
                                                        @click="toggleAccordion('dataset-column-mappings')" >
                                                        <h4 class="mb-0">Column Mappings</h4>
                                                    </button>
                                                </div>
                                                <div class="accordion-body accordion-collapse collapse pt-0" id="dataset-column-mappings"
                                                    :class="active_accordion === 'dataset-column-mappings' ? 'show' : ''">
                                                    <div class="row">
                                                        <div class="col mb-3">
                                                            <p class="pb-2">Based upon the "Data Category" selected, there are several mandatory and optional fields to be mapped. <strong>If you have additional columns you'd like to use for filters, be sure to add those columns too.</strong></p>

                                                            <column-mapping 
                                                                :id="'dataset-column-mappings-'+dataset.id" 
                                                                :key="'dataset-column-mappings-'+dataset.id+'-'+(dataset.source_type_id || dataset.source_type || '')"
                                                                v-if="if_dest_columns_loaded" 
                                                                :client="client" 
                                                                :dataset="dataset" 
                                                                :dest_columns="dataset.dest_columns"
                                                                ref="column_mapping" 
                                                                :modelValue="dataset.columns"
                                                                @update:modelValue="updateColumns($event, index)"
                                                                :data_source_id="dataset.id"
                                                                :source="dataset.data_source"
                                                                :if_allow_edit="canEdit('connections')">
                                                            </column-mapping>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col">
                                                            <div class="alert alert-danger mb-3" v-if="column_mapping_form.error">
                                                                There was an issue saving the data set. Check the fields above to get more information.
                                                            </div>
                                                            <!-- Save Button -->
                                                            <div>
                                                                <div v-if="!canEdit('connections')" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                                                                    <button type="submit" class="btn btn-primary" :disabled="true">
                                                                        <div v-if="column_mapping_form.busy" class="spinner-border  spinner-border-sm float-left ms-1" role="status"></div>
                                                                        <img v-else class="icon me-1" src="/img/icons/avid-icons/save.svg" alt="" > Save
                                                                    </button>
                                                                </div>
                                                                <button v-else type="submit" class="btn btn-primary" @click="saveColumnMapping(dataset, index)" :disabled="column_mapping_form.busy">
                                                                    <div v-if="column_mapping_form.busy" class="spinner-border  spinner-border-sm float-left ms-1" role="status"></div>
                                                                    <img v-else class="icon me-1" src="/img/icons/avid-icons/save.svg" alt="" > Save
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card accordion mb-0" key="dataset-join-builder">
                                            <div class="accordion-item">
                                                <div class="accordion-header">
                                                    <button class="accordion-button" type="button"
                                                        :data-bs-target="'#dataset-join-builder'" data-bs-toggle="collapse"
                                                        aria-expanded="false" :aria-controls="'dataset-join-builder'"
                                                        :class="{ collapsed: active_accordion !== 'dataset-join-builder' }"
                                                        @click="toggleAccordion('dataset-join-builder')">
                                                        <h4 class="mb-0">Join Additional Data</h4>
                                                    </button>
                                                </div>
                                                <div class="accordion-body accordion-collapse collapse pt-0" id="dataset-join-builder"
                                                    :class="active_accordion === 'dataset-join-builder' ? 'show' : ''">
                                                    <div class="row">
                                                        <div class="col mb-4 ">
                                                            <p class="mb-2">There are times when it is helpful to combine multiple data sources into a single set. You have the ability to connect the data in the
                                                                <em>{{dataset.name}}</em> data set to another data set below.</p>
                                                            <p class="mb-2">To combine the data, you'll need to map the fields in the supplemental data set first. Once done, you'll come back to this data set,
                                                                select the supplemental data set from the drop down and then determine what fields will be used to join the two sets. Once all of that is saved,
                                                                the new fields will be available for mapping in the section above. (<em>The columns available for use in the supplemental data set are only those which have been mapped.</em>)</p>
                                                            <p class="mb-3">For a step-by-step explanation,
                                                                <a href="https://help.avidai.com/hc/en-us/articles/42928661962771-How-to-Join-Outside-Data-into-Existing-System-Data" target="_blank">please check out the Avid's knowledge base.</a></p>
                                                            <join-builder :id="'dataset-join-builder-'+dataset.id" :key="dataset.id" :client="client" :dataset="dataset" :all_datasets="all_datasets"
                                                                v-model="dataset.joins" ref="join_builder" :if_allow_edit="canEdit('connections')"></join-builder>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col">
                                                            <div class="alert alert-danger mb-3" v-if="join_builder_form.error">
                                                                There was an issue saving the data set. Check the fields above to get more information.
                                                            </div>
                                                            <!-- Save Button -->
                                                            <div>
                                                                <div v-if="!canEdit('connections')" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                                                                    <button type="submit" class="btn btn-primary" :disabled="true">
                                                                        <img class="icon me-1" src="/img/icons/avid-icons/save.svg" alt=""> Save
                                                                    </button>
                                                                </div>
                                                                <button v-else type="submit" class="btn btn-primary" @click="saveJoinBuilder(dataset, index)" :disabled="join_builder_form.busy">
                                                                    <div v-if="join_builder_form.busy" class="spinner-border spinner-border-sm float-left ms-1" role="status"></div>
                                                                    <img v-else class="icon me-1" src="/img/icons/avid-icons/save.svg" alt="">Save
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card accordion mb-0" key="dataset-details-segments" v-if="canView('pathways') || canView('direct_mail')">
                                            <div class="accordion-item">
                                                <div class="accordion-header">
                                                    <button class="accordion-button" type="button"
                                                        :data-bs-target="'#dataset-details-segments'" data-bs-toggle="collapse"
                                                        aria-expanded="false" :aria-controls="'dataset-details-segments'"
                                                        :class="{ collapsed: active_accordion !== 'dataset-details-segments' }"
                                                        @click="toggleAccordion('dataset-details-segments')" >
                                                        <h4 class="mb-0">Audiences ({{dataset.segments ? dataset.segments.length : 0}})</h4>
                                                    </button>
                                                </div>
                                                <div class="accordion-body accordion-collapse collapse pt-0" id="dataset-details-segments"
                                                    :class="active_accordion === 'dataset-details-segments' ? 'show' : ''">
                                                    <div class="d-flex flex-column gap-2">
                                                        <div class="w-100 card table-card" v-if="dataset.segments && (dataset.segments.length > 0 || (dataset.segments.length == 0 && search_key !=''))">
                                                            <div class="card-header">
                                                                <div class="d-flex flex-row justify-content-between gap-2">
                                                                    <div class="position-relative flex-grow-1">
                                                                        <input type="text" class="search-box form-control" placeholder="Search by Audience Name..." aria-label="Search by Audience Name..." v-model="search_key" @input="searchSegment(index)">
                                                                        <i class="fa fa-search search-placeholder-icon" v-if="search_key == ''"></i>
                                                                    </div>
                                                                    <div class="d-flex justify-content-start align-items-center" v-if="canEdit('pathways') || canEdit('direct_mail')">
                                                                        <a class="btn btn-secondary float-end" :href="'/audience/'+client.url+'/new?dataset='+dataset.id">
                                                                            <i class="fa fas fa-fw fa-plus"></i> Add an Audience
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="card-body p-0">
                                                                <table class="table table-width-responsive table-without-pagination m-0">
                                                                    <thead>
                                                                        <tr class="table-header-row">
                                                                            <th @click="sortByKey('name', dataset)">
                                                                                <div class="d-flex flex-row">
                                                                                    Audience
                                                                                    <div class="d-flex flex-column">
                                                                                        <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key=='name' && sort_order=='asc')? 'sort-key-active' :''" alt="">
                                                                                        <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key=='name' && sort_order=='des')? 'sort-key-active' :''" alt="">
                                                                                    </div>
                                                                                </div>
                                                                            </th>
                                                                            <th @click="sortByKey('size', dataset)">
                                                                                <div class="d-flex flex-row">
                                                                                    Contacts
                                                                                    <div class="d-flex flex-column">
                                                                                        <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key=='size' && sort_order=='asc')? 'sort-key-active' :''" alt="">
                                                                                        <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key=='size' && sort_order=='des')? 'sort-key-active' :''" alt="">
                                                                                    </div>
                                                                                </div>
                                                                            </th>
                                                                            <th style="width:120px;" v-if="canEdit('pathways') || canEdit('direct_mail')">Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-if="dataset.segments.length == 0 && search_key != ''" class="table-row-1 no-results-text">
                                                                            <td class="align-start">
                                                                                There is no file match the given search.
                                                                            </td>
                                                                        </tr>
                                                                        <tr v-for="(segment, i) in dataset.segments" :class="`table-row-${i+1}`"v-else>
                                                                            <td class="align-start vertical-align-center ">
                                                                                {{ segment.name }}
                                                                            </td>
                                                                            <td class="vertical-align-center ">
                                                                                {{ number_with_zero(getDefaultSize(segment.sizes)) }}
                                                                            </td>

                                                                            <td class="align-start" v-if="canEdit('pathways') || canEdit('direct_mail')">
                                                                                <div class="dropdown d-flex justify-content-center">
                                                                                    <button class="btn btn-white btn-icon-only-md" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                                                                        <img class="icon" src="/img/icons/avid-icons/dots-vertical.svg" alt="">
                                                                                    </button>
                                                                                    <div class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                                                                                        <a class="dropdown-item" :href="'/audience/' + client.url +'/' + segment.id">
                                                                                            <img class="icon me-2" src="/img/icons/avid-icons/edit.svg" alt=""> Edit Audience
                                                                                        </a>
                                                                                        <a class="dropdown-item" :href="'/audience/' + client.url +'/clone/' + segment.id">
                                                                                            <img class="icon me-2" src="/img/icons/avid-icons/document-copy.svg" alt=""> Copy Audience
                                                                                        </a>
                                                                                        <hr class="my-1">
                                                                                        <a class="dropdown-item text-danger" href="#" @click.prevent="deleteSegment(segment, index, i)">
                                                                                            <img class="icon red-icon me-2" src="/img/icons/avid-icons/trash.svg" alt=""> Delete Audience
                                                                                        </a>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                        <div v-else>
                                                            <h6>No audiences have been created yet.
                                                                <a :href="'/audience/'+client.url+'/new?dataset='+dataset.id" v-if="canEdit('pathways') || canEdit('direct_mail')">Click here to make a new audience.</a>
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h4 class="mt-3" v-else>There are currently no data sets created for this connection.</h4>

                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="preview-modal" aria-labelledby="preview-modal" aria-hidden="true">
            <div class="modal-dialog " :class="modal_size">
                <div class="modal-content">
                    <div class="modal-header border-bottom-0 pb-0">
                        <div class="text-center w-100">
                            <button type="button" class="btn btn-white float-end close-modal" data-bs-dismiss="preview-modal" @click="closePreviewModal()">
                                <img class="icon me-0" src="/img/icons/avid-icons/close.svg" alt=""> 
                            </button>
                            <h3 class="mt-2">Preview File Contents</h3>
                        </div>
                    </div>
                    <div class="modal-body p-0">
                        <div v-if="typeof table_data === 'string' && table_data == ''" class="m-2 mb-4 text-center">
                            <div class="d-inline-block spinner-border spinner-border-sm ms-2" role="status"> <span class="visually-hidden">Loading...</span></div>
                            <span class="ms-2">Loading...</span>
                        </div>
                        <div v-else-if='Array.isArray(table_data) && table_data.length > 0'>
                            <div class="card table-card table-responsive">
                                <table class="table table-with-pagination table-striped mb-0">
                                    <thead>
                                        <tr>
                                            <th v-for="(row, index) in Object.keys(table_data[0])" class='align-middle pt-0'
                                                :class="(index==0) ? 'ps-3' : ''">{{originalHeader(row)}}</th>
                                        </tr>
                                    </thead>
                                    <tbody class="table-border-bottom-0">
                                        <tr v-for="row in table_data" >
                                            <td v-for="(col, index) in row" :class="(index==0) ? 'ps-3' : ''">{{ col }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div v-else-if='Array.isArray(table_data) && table_data.length == 0'>
                            <div class="alert alert-warning m-2"  >
                                No data was returned.
                            </div>
                        </div>
                        <div v-else>
                            <div class="alert alert-danger m-2" >
                                There was an error pulling the data:<br>
                                <em>{{table_data}}</em>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <system-modal 
            v-if="connection_selected"
            :client="client" 
            :integrations="[]" 
            :connections="[]" 
            :connection_selected="connection_selected" 
            @resetModal="resetModal">
        </system-modal>
        <support-modal-dynamic :user="user" :client="client" :selected_ticket_type="selected_ticket_type" :id="'support-modal-'+selected_ticket_type"></support-modal-dynamic>
        
        <!-- Filter Proposal Modal -->
        <filter-proposal-modal
            v-for="(dataset, index) in local_datasets"
            :key="'filter-modal-' + dataset.id"
            :ref="'filterProposalModal' + dataset.id"
            :client="client"
            :data-set-id="dataset.id"
            @accepted="handleFilterProposalAccepted"
        />
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import permissionsMixin from '../../mixins/permissions';
import { useNotifications } from '../../composables/useNotifications';
import { useAISuggestionPolling, createDataSetFilterCheckFunction } from '../../composables/useAISuggestionPolling';
import FilterProposalModal from '../components/FilterProposalModal.vue';

export default defineComponent({
    mixins: [permissionsMixin],
    components: {
        FilterProposalModal,
    },
    setup() {
        const { showNotification } = useNotifications();
        const { startPolling, stopPolling, isPolling } = useAISuggestionPolling();
        return {
            showNotification,
            startPolling,
            stopPolling,
            isPolling
        };
    },
    props: ['user', 'client', 'selected_connection_or_file', 'all_datasets'],
    data() {
        return {
            source_types: [],
            file_or_connection: null,
            local_connection: null,
            local_file: null, // file passed from props
            local_files: [], //files returned from search pattern

            local_datasets: [],
            active_tab_index: 0,
            if_editing_dataset_name: false,
            errors: {
                name: ''
            },

            // File preview data modal
            modal_size: 'modal-xl',
            table_data: null,
            current_file: null,

            // segment table search and sort
            search_key: '',
            sort_key: null,
            sort_order: 'asc',
            active_accordion: null,

            // For Data Set Mapping Accordion
            information_form: {
                error: false,
                busy: false
            },
            join_builder_form:{
                error: false,
                busy: false
            },
            inclusion_filter_form:{
                error: false,
                busy: false
            },
            filterSuggestionDisabled: {}, // Track disabled state per dataset index
            column_mapping_form:{
                error: false,
                busy: false
            },
            errors: {
                name: '',
                category: '',
                pattern: '',
                filter: ''
            },
            if_dest_columns_loaded: false,
            connection_selected:{},
            selected_ticket_type: ''
        };
    },
    beforeMount() {
        const params = new URLSearchParams(window.location.search);
        if(params.get('connection') != null){
            this.file_or_connection = 'connection';
            this.local_connection = this.selected_connection_or_file;
            // Create a reactive copy of the datasets
            if (this.selected_connection_or_file.datasets && this.selected_connection_or_file.datasets.length > 0) {
                this.local_datasets = this.selected_connection_or_file.datasets.map(dataset => ({
                    ...dataset,
                    columns: dataset.columns ? [...dataset.columns] : []
                }));
            } 
        } else {
            this.file_or_connection = 'file';
            this.local_file = this.selected_connection_or_file;
            if (this.selected_connection_or_file.dataset) {
                // Create a reactive copy of the dataset
                this.local_datasets = [{
                    ...this.selected_connection_or_file.dataset,
                    columns: this.selected_connection_or_file.dataset.columns ? [...this.selected_connection_or_file.dataset.columns] : []
                }];
            }
        }
        //Sort the local_datasets by their name
        this.local_datasets.sort((a, b) => (a.name > b.name) ? 1 : -1);
        if(params.get('ds_id')){
            //Find the index of the dataset with the id = ds_id
            for(let i = 0; i < this.local_datasets.length; i++){
                if(this.local_datasets[i].id == params.get('ds_id')){
                    this.active_tab_index = i;
                    break;
                }
            }
        }

        // Set up event listener for filter proposals
        window.addEventListener('openFilterProposal', this.handleOpenFilterProposalEvent);
        
        // Set up event listener for re-enabling suggestion buttons on validation failure
        window.addEventListener('reEnableSuggestion', this.handleReEnableSuggestion);

        if(params.get('connection') == null || this.isFileConnection()){
            //Make a null settings into an object
            for(let i = 0; i < this.local_datasets.length; i++ ){
                //Loop through the local datasets

                if(this.local_datasets[i].settings == null) {
                    this.local_datasets[i].settings = {ignore_unused: true, refresh_type: 'full', id_columns: [], pattern: ''};
                }else if(this.local_datasets[i].settings.ignore_unused == null)
                    this.local_datasets[i].settings.ignore_unused = true;
            }
            //Only get the first DS's files
            this.refreshFiles();
        }

        // Listen for sync job updates
        if (this.local_connection) {
            this.listenForUpdates();
        }

        window.axios.get('/api/integration/data_source/data_set')
            .then(response => {
                if(response.status == 200) {
                    this.source_types = response.data.options;
                    this.constructDestColumnArray();
                }
            });
    },

    computed: {
        id_columns() {
            //Loop through the local_dataset.settings.id_columns array (if it isn't null)
            //and return the column names
            if(this.local_datasets[this.active_tab_index].settings.id_columns == null || this.local_datasets[this.active_tab_index].source_columns == null)
                return '';
            else {
                let id_cols = this.local_datasets[this.active_tab_index].settings.id_columns;
                if(id_cols && id_cols.length > 0){
                    var col = this.local_datasets[this.active_tab_index].source_columns[id_cols[0]] || id_cols[0];
                    for(var i = 1; i < id_cols.length; i++) {
                        const columnName = this.local_datasets[this.active_tab_index].source_columns[id_cols[i]] || id_cols[i];
                        col += ", " + columnName;
                    }
                    return col;
                }
                return '';
            }
        },
        sortedSourceColumns() {
            if (!this.local_datasets[this.active_tab_index] || !this.local_datasets[this.active_tab_index].source_columns) {
                return {};
            }
            
            // Convert to array of [key, value] pairs, sort by value (case-insensitive), then convert back to object
            const sortedEntries = Object.entries(this.local_datasets[this.active_tab_index].source_columns)
                .sort(([,a], [,b]) => a.toLowerCase().localeCompare(b.toLowerCase()));
            
            return Object.fromEntries(sortedEntries);
        }
    },
    methods: {
        listenForUpdates() {
            window.Echo.private(`client.${this.client.id}`)
                .listen('SyncJobUpdated', (e) => {
                    if (this.local_connection && this.local_connection.id === e.connection_id) {
                        // Update the connection's active jobs if it's currently syncing
                        const busyStatuses = ['queued', 'pending', 'running', 'working'];
                        if (busyStatuses.includes(e.status)) {
                            this.local_connection.active_jobs = [{
                                rowsSynced: e.rowsSynced || 0
                            }];
                            this.local_connection.last_synced_at = e.started_at;
                        } else {
                            this.local_connection.active_jobs = [];
                            this.local_connection.last_synced_at = e.finished_at;
                        }

                        // Update error message if there is one
                        this.local_connection.sync_error_msg = e.error_msg;

                        this.$forceUpdate();
                    }
                });
        },
        getDefaultSize(sizes) {
            if(!sizes)
                return null;
            for (var i = 0; i < sizes.length; i++){
                if (sizes[i].id == 0)
                    return sizes[i].size;
            }
            return null
        },
        getSourceColumnsWithJoin(dataset){
            //Return the source columns with the join column
            if(dataset.joins == null || dataset.joins.length == 0)
                return dataset.source_columns;
            else{
                //Copy the object
                let arr = JSON.parse(JSON.stringify(dataset.source_columns));
                for(let i = 0; i < dataset.joins.length; i++){
                    //If the columns haven't been added on to it yet, skip. (It'll be added on the next iteration)
                    if(dataset.joins[i].joined_data_set == null || dataset.joins[i].joined_data_set.columns == null)
                        continue;

                    let cols = dataset.joins[i].joined_data_set.columns;
                    //Skip the first one since it is the custom column mapping option
                    for(let j = 1; j < cols.length; j++){
                        // Ensure the column definition has a value before processing to avoid errors
                        if (!cols[j] || !cols[j].value) {
                            continue; // Skip invalid / placeholder entries
                        }

                        let col = cols[j].value;
                        //Remove all text before the last .
                        col = col.substring(col.lastIndexOf('.')+1);
                        //Append the dataset join name but replace all space with a _ and make lowercase
                        //Also remove all non-alphanumeric characters
                        col = dataset.joins[i].name.replace(/ /g, "_").replace(/[^a-zA-Z0-9_.]/g, '').toLowerCase() + "_." + col;
                        // If a display name isn't present use the generated column key as a fallback
                        arr[col] = cols[j].display_name ?? col;
                    }
                }
                return arr;
            }
        },
        // Toggle accordion visibility
        toggleAccordion(accordion_id) {
            if (this.active_accordion === accordion_id) {
                this.active_accordion = null; // Close if already open
            } else {
                this.active_accordion = accordion_id; // Open the clicked accordion
            }
        },
        // Close all accordions
        closeAllAccordions() {
            this.active_accordion = null;
        },
        isFileConnection() {
            //SFTP, Remote SFTP, or File Upload
            return this.selected_connection_or_file.integration_id == "7dbce608-4906-4606-977c-32ab1259b2e6" 
                || this.selected_connection_or_file.integration_id == "397b5b86-e954-495f-8fdb-513885f53251" 
                || this.selected_connection_or_file.integration_id == "71b0c3b0-8390-49ec-9984-1c04b7384d38"
                || this.selected_connection_or_file.integration_id == "323ce508-d21b-44ec-8064-5623e498ad13";
        },
        constructDestColumnArray(){
            for (var i = 0; i < this.local_datasets.length; i++){
                //Set the fake "source type id" column and the types of columns
                if(this.local_datasets[i].source_type != null){
                    //Foreach to loop through the dest_columns object
                    for (const key in this.source_types) {
                        //Need to match on source type and source subtype (which can be null)
                        if(this.source_types[key][0].source_type == this.local_datasets[i].source_type &&
                            (this.local_datasets[i].source_subtype == null &&
                                this.source_types[key][0].source_subtype == null ||
                                this.local_datasets[i].source_subtype == this.source_types[key][0].source_subtype)){

                                this.local_datasets[i].source_type_id = key;
                                this.local_datasets[i].dest_columns = this.source_types[key];

                        }
                    }
                    if(Array.isArray(this.local_datasets[i].columns) && this.local_datasets[i].columns.length == 0)
                        this.local_datasets[i].columns = null;
                }

                //If the source_columns isn't set...
                if(this.local_datasets[i].source_columns == null && this.local_files.length >= 1) {
                    this.local_datasets[i].source_columns = this.local_files[0].columns;
                }
            }
            this.if_dest_columns_loaded = true;
            this.$forceUpdate();
        },
        searchSegment(dataset_index){
            if(this.search_key == "") {
                if(this.file_or_connection == 'connection'){
                    this.local_datasets[dataset_index].segments = [...this.selected_connection_or_file.datasets[dataset_index].segments]

                } else {
                    this.local_datasets[dataset_index].segments = [...this.selected_connection_or_file.dataset.segments]
                }
            } else { // for orgs with small file list
                this.local_datasets[dataset_index].segments = this.local_datasets[dataset_index].segments.filter(option => option.name.toLowerCase().includes(this.search_key.toLowerCase()));
            }
        },
        sortByKey(key, dataset){
            this.sort_key = key;
            if (this.sort_key != key){
                this.sort_order = 'asc'; // reset to ascending sorting order
            } else{
                this.sort_order = (this.sort_order == 'asc'? 'des':'asc');
            }
            this.sortDataWithLabel(dataset);
        },
        sortDataWithLabel(dataset){
            if(this.sort_order == 'asc')
                dataset.segments.sort((a, b) => (a[this.sort_key ] > b[this.sort_key ]) ? 1 : -1);
            else
                dataset.segments.sort((a, b) => (a[this.sort_key ] < b[this.sort_key ]) ? 1 : -1);
        },
        refreshFiles() { // for files only
            this.errors.pattern = "";
            if(this.local_datasets[this.active_tab_index] && this.local_datasets[this.active_tab_index].settings.pattern != "")
                window.axios.post('/api/files/' + this.client.url + '/list_by_pattern',
                    {'pattern': this.local_datasets[this.active_tab_index].settings.pattern }).then(response => {

                    this.local_files = response.data.files;
                    if(this.local_files.length > 0) {
                        this.local_datasets[this.active_tab_index].source_columns = this.local_files[0].columns;
                        // Clean up invalid id_columns after source_columns are updated
                        this.cleanInvalidIdColumns();
                    }
                    this.$forceUpdate();

                  });
            else {
                this.errors.pattern = "You must specify a pattern to identify current and future files with.";
                this.local_files = [];
            }
        },
        canSync(){
            //The SFTPs
            if(this.local_connection.integration_id == '7dbce608-4906-4606-977c-32ab1259b2e6' || this.local_connection.integration_id == '397b5b86-e954-495f-8fdb-513885f53251')
                return false
            //File upload or File Forwarding
            if(this.local_connection.integration_id == '71b0c3b0-8390-49ec-9984-1c04b7384d38' || this.local_connection.integration_id == '323ce508-d21b-44ec-8064-5623e498ad13')
                return false;

            if (!this.local_connection.active_jobs){
                this.local_connection.active_jobs = [];
            }
            return this.local_connection.active_jobs.length == 0;
        },
        canDelete(){
            //Can't delete the File Upload connection
            return this.local_connection.integration_id != '71b0c3b0-8390-49ec-9984-1c04b7384d38';
        },
        setActiveTab(index){
            this.active_tab_index = index;
            this.changeDatasetSelection();
            this.resetErrors();
        },
        resetErrors(){
            this.information_form = {
                error: false,
                busy: false
            };
            this.inclusion_filter_form = {
                error: false,
                busy: false
            };
            this.column_mapping_form = {
                error: false,
                busy: false
            };
        },
        cleanInvalidIdColumns() {
            // Clean up id_columns that no longer exist in source_columns
            const dataset = this.local_datasets[this.active_tab_index];
            if (dataset && dataset.settings && dataset.settings.id_columns && dataset.source_columns) {
                const validColumns = Object.keys(dataset.source_columns);
                dataset.settings.id_columns = dataset.settings.id_columns.filter(colKey => 
                    validColumns.includes(colKey)
                );
            }
        },
        handleRefreshTypeChange() {
            // Clean up invalid id_columns when refresh_type changes
            this.$nextTick(() => {
                this.cleanInvalidIdColumns();
                // Then run the normal validation
                this.columnsValid();
            });
        },
        columnsValid() {
            // If it is incremental, all of the local files columns need to match (or be in the most recent one)
            if(this.local_datasets[this.active_tab_index].settings && this.local_datasets[this.active_tab_index].settings.refresh_type == 'incremental' && this.local_files.length > 1){
                //Check if the URL has "mapping/file" in it
                var recent_file = this.local_files[0];
                var file_id = -1;
                if(window.location.pathname.indexOf("mapping/file") != -1){
                    //Get the fileID from the URL and update the "recent_file" with that file
                    var split = window.location.pathname.split("/");
                    file_id = split[split.length - 1];
                    for(var i = 0; i < this.local_files.length; i++)
                        if(this.local_files[i].id == file_id){
                            recent_file = this.local_files[i];
                            break;
                        }
                }

                //Get an array of the keys of the recent_file.columns object
                var compare_columns = Object.keys(recent_file.columns);
                if(this.local_datasets[this.active_tab_index].settings.ignore_unused){
                    compare_columns = this.getUsedColumns();
                }

                for(var i = 0; i < compare_columns.length; i++){
                    //If compare_columns is an object, get the value
                    if(typeof compare_columns[i] == 'object'){
                        compare_columns[i] = compare_columns[i].value;
                    }
                }
                this.information_form.error = false;

                //Look through all of the files
                for(var i = 0; i < this.local_files.length; i++){
                    //Don't worry about the files we're comparing it to
                    if(this.local_files[i].id == recent_file.id)
                        continue;

                    this.local_files[i].status_msg = "";
                    //Loop through each of the columns
                    for (let key in compare_columns) {
                        const colKey = compare_columns[key];
                        // Joined columns (e.g. joinname_.field) are not in local file columns; skip them
                        const isJoinedColumn = colKey && colKey.includes('_.');
                        if (isJoinedColumn) continue;
                        //If it isn't in the current file's list of columns, throw an error
                        if (!(colKey in this.local_files[i].columns)){
                            var file_language = "the most recent";
                            if(file_id >= 0)
                                file_language = "your selected";
                            this.errors.pattern = "The files identified by the given pattern have one or more columns missing when compared to "+file_language+" file. Please update the pattern or delete the files identified in the table.";
                            this.information_form.error = true;
                            this.local_files[i].status_msg = "MISMATCH";
                            break;
                        }
                    }
                }
            } else {
                //Reset the status message of the files in case they had previously been flagged
                for(var i = 0; i < this.local_files.length; i++)
                    this.local_files[i].status_msg = "";
            }

            return !this.information_form.error;

        },
        getUsedColumns(){
            // Get all of the mapped columns from the column definitions relationship
            let columns = this.local_datasets[this.active_tab_index].columns;
            let arr = [];

            // If there are identified ID columns
            let settings = this.local_datasets[this.active_tab_index].settings;
            if (settings.id_columns && settings.refresh_type && settings.refresh_type === 'incremental') {
                // Merge the array into arr
                arr = [...arr, ...settings.id_columns];
            }

            columns.forEach(c => {
                // If it isn't a custom definition
                if (c.source_column !== 'CUSTOM') {
                    // Insert it only if it isn't already in the array (and it has been mapped)
                    if (!arr.includes(c.source_column) && c.source_column) {
                        arr.push(c.source_column);
                    }
                } else {
                    let logic = c.column_logic;
                    // Check each unit
                    logic.units.forEach(unit => {
                        // Check the value type
                        if (unit.value_type === 'column' && !arr.includes(unit.value)) {
                            arr.push(unit.value);
                        }

                        // Now loop through the logic units
                        unit.logic.logic_units.forEach(u => {
                            // If the right side of the equation is a column mapping
                            if (!u.is_static && !u.show_options && !arr.includes(u.value.value)) {
                                arr.push(u.value.value);
                            }
                            // Get the left side of the equation
                            if (!arr.includes(u.db_column.value)) {
                                arr.push(u.db_column.value);
                            }
                        });
                    });

                    // Check the default type
                    if (logic.default_type === 'column' && !arr.includes(logic.default_value)) {
                        arr.push(logic.default_value);
                    }
                }
            });

            return arr;

        },
        changeDatasetSelection(){
            this.if_editing_dataset_name = false;
            this.search_key = '';
            this.sort_key = null;
            this.sort_order = 'asc';

            if(this.file_or_connection == 'connection'){
                // Preserve dest_columns if already present in local_datasets
                this.local_datasets = this.selected_connection_or_file.datasets.map(dataset => {
                    // Try to find the matching dataset in the current local_datasets
                    const existing = this.local_datasets.find(d => d.id === dataset.id);
                    return {
                        ...dataset,
                        columns: dataset.columns ? [...dataset.columns] : [],
                        dest_columns: existing && existing.dest_columns ? existing.dest_columns : dataset.dest_columns
                    };
                });
            } else {
                // this.local_file = this.selected_connection_or_file;
                if (this.selected_connection_or_file.dataset)
                    this.local_datasets = [this.selected_connection_or_file.dataset];
            }            

            //Sort the local_datasets by their name
            this.local_datasets.sort((a, b) => (a.name > b.name) ? 1 : -1);
            //Get the id of the active_tab_index for the local_dataserts
            let ds_id = this.local_datasets[this.active_tab_index].id;
            //Get the current URL
            let url = window.location.pathname + window.location.search;
            //Remove the ds_id= from the URL if it exists
            url = url.replace(/ds_id=\d+/, '');
            //If the url ends with &, remove it
            if(url.endsWith('&'))
                url = url.slice(0, -1);
            window.history.pushState({}, '', url + "&ds_id=" + ds_id);

            if(this.file_or_connection == 'file' || this.isFileConnection())
                this.refreshFiles();

            if (this.source_types && Object.keys(this.source_types).length > 0) {
                this.constructDestColumnArray();
            }
        },
        updateIsPrimary(set) {
            set.is_primary = true;
            this.saveDataSet(set);

            // var new_status = !set.is_primary;
            for(var i = 0; i < this.local_datasets.length; i++) {
                if(this.local_datasets[i].id != set.id && this.local_datasets[i].source_type == set.source_type && (this.local_datasets[i].source_subtype == set.source_subtype)) {
                    this.local_datasets[i].is_primary = false; //Only set one dataset under the same source_type and source_subtype to true, the rest should all be false
                    this.saveDataSet(this.local_datasets[i]);
                }
                else if(this.local_datasets[i].id == set.id) {
                    this.local_datasets[i].is_primary = true;
                }
            }

            this.showNotification({
                text: 'The data set status has been updated and a rebuild has triggered. The changes will be reflected when the process is complete.'
            });
        },
        saveDataSet(set) {
            //Make a deep copy of the dataset so that I can remove the columns to prevent them from being saved
            set = JSON.parse(JSON.stringify(set));
            //Unset the columns
            set.columns = null;

            //Post to the api end point to update the dataset
            window.axios.put('/api/data_set/'+this.client.url + '/' + set.id, set).catch(error => {
                this.showNotification({
                    text: 'Failed to save the data set. ' + (error.response?.data?.message || 'Please try again.'),
                    type: 'error'
                });
            });;
        },
        toggleEditName(){
            this.if_editing_dataset_name = true;
        },
        cancelEditName(index){
            this.if_editing_dataset_name = false;

            if(this.local_connection){
                this.local_datasets[index].name = this.local_connection.datasets[index].name;
            } else {
                this.local_datasets[index].name = this.local_file.dataset.name;
            }
        },
        saveDataSetName(index){
            if(this.local_datasets[index].name != ''){
                this.if_editing_dataset_name = false;
                this.saveDataSet(this.local_datasets[index]);
            } else {
                this.errors.name = "The Data Set name cannot be empty";
                return;
            }
        },
        saveInformation(dataset, index){
            if(dataset.name == "") {
                this.errors.name = "Please enter a name for this data set.";
                this.information_form.error = true;
            }else if((dataset.source != 'Airbyte' && dataset.source != 'Table') && dataset.settings.pattern == '') {
                this.errors.pattern = "Please enter a file pattern to use to identify subsequently uploaded files.";
                this.information_form.error = true;
            } else if(dataset.source != 'Airbyte' && dataset.source != 'Table' && this.local_files.length == 0 ) {
                this.errors.pattern = "The current pattern doesn't have any matching files. Please update it to match files that have already been uploaded.";
                this.information_form.error = true;
            } else {
                this.information_form.error = false;
            }

            if(!this.information_form.error){
                //If something has changed, update the dataset
                if(this.datasetHasChanged(dataset, index)){
                    const saved_dataset = (this.file_or_connection == 'connection' ? this.selected_connection_or_file.datasets[index] : this.selected_connection_or_file.dataset);
                    const typeChanged = dataset.source_type != saved_dataset.source_type || dataset.source_subtype != saved_dataset.source_subtype;

                    const doSave = () => {
                        this.information_form.busy = true;
                        const datasetCopy = JSON.parse(JSON.stringify(dataset));
                        datasetCopy.columns = null;
                        datasetCopy.update_type = 'information';

                        window.axios.put('/api/data_set/'+this.client.url+ '/' + datasetCopy.id, datasetCopy).then(response => {
                            const data = response.data.data;
                            let dest_columns = this.local_datasets[index].dest_columns;
                            if (typeChanged) {
                                for (const key in this.source_types) {
                                    if (this.source_types[key][0].source_type === data.source_type &&
                                        (this.source_types[key][0].source_subtype === data.source_subtype ||
                                            (this.source_types[key][0].source_subtype == null && data.source_subtype == null))) {
                                        dest_columns = this.source_types[key];
                                        break;
                                    }
                                }
                                this.local_datasets[index] = {
                                    ...data,
                                    dest_columns: dest_columns ? [...dest_columns] : [],
                                    columns: [],
                                    joins: data.joins || []
                                };
                            } else {
                                this.local_datasets[index] = {
                                    ...data,
                                    dest_columns: dest_columns ? [...dest_columns] : []
                                };
                            }
                            this.constructDestColumnArray();
                            // Update the selected_connection_or_file
                            if (this.file_or_connection === 'connection') {
                                const pIdx = this.selected_connection_or_file.datasets.findIndex(ds => ds.id === this.local_datasets[index].id);
                                if (pIdx !== -1) {
                                    this.selected_connection_or_file.datasets.splice(pIdx, 1, { ...this.local_datasets[index] });
                                }
                            } else if (this.file_or_connection === 'file') {
                                this.selected_connection_or_file.dataset = { ...this.local_datasets[0] };
                            }
                            this.information_form.busy = false;
                            this.showNotification({
                                text: 'Your data set information was successfully saved!'
                            });
                            this.closeAllAccordions();
                            this.$forceUpdate();
                        }).catch(error => {
                            this.information_form.busy = false;
                            this.showNotification({
                                text: 'Error saving the data set! ' + (error.response?.data?.message || 'Please try again.'),
                                type: 'error'
                            });
                        });
                    };

                    if (typeChanged) {
                        window.Swal.fire({
                            title: 'Change data set type?',
                            html: 'Making this change will remove any fields that have been mapped, remove any joins that have been created, and will reset the primary status. Do you want to continue?',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Yes',
                            cancelButtonText: 'Cancel',
                            customClass: { popup: 'swal-warning' }
                        }).then((result) => {
                            if (result.isConfirmed) {
                                doSave();
                            }
                        });
                    } else {
                        doSave();
                    }
                }
            }
        },
        datasetHasChanged(updated_dataset, index) {
            var saved_dataset = (this.file_or_connection == 'connection'? this.selected_connection_or_file.datasets[index]: this.selected_connection_or_file.dataset);

            //If any of the following are different from the dataset prop
            if(updated_dataset.settings.ignore_unused != saved_dataset.ignore_unused)
                return true;
            if(updated_dataset.settings.pattern != saved_dataset.pattern)
                return true;
            if(updated_dataset.settings.refresh_type != saved_dataset.refresh_type)
                return true;
            //ID_Columns is an array, so we need to compare the contents
            if(!this.arraysEqual(updated_dataset.settings.id_columns, saved_dataset.id_columns))
                return true;
            if(updated_dataset.source_type != saved_dataset.source_type || updated_dataset.source_subtype != saved_dataset.source_subtype)
                return true;
            return false;
        },
        setDataSourceType(index) {
            const dataset = this.local_datasets[index];
            if (!this.source_types[dataset.source_type_id]) return;
            dataset.source_type = this.source_types[dataset.source_type_id][0].source_type;
            dataset.source_subtype = this.source_types[dataset.source_type_id][0].source_subtype;
            dataset.dest_columns = this.source_types[dataset.source_type_id];
            dataset.columns = [];
            this.$forceUpdate();
        },
        hasTypeChanged(dataset, index) {
            const saved = (this.file_or_connection === 'connection' ? this.selected_connection_or_file.datasets[index] : this.selected_connection_or_file.dataset);
            return saved && (dataset.source_type !== saved.source_type || dataset.source_subtype !== saved.source_subtype);
        },
        getCategoryDescription(category) {
            const descriptions = {
                'Transactions': 'Use this for financial transaction exports from your CRM system. Each row should represent a single gift or payment.',
                'Email Form Submissions': 'Use this for individual form submissions collected through your website or landing page software. Each row should represent one unique submission.',
                'Donation Form Submissions': 'Use this for submissions from your donation form platform. Each entry should represent a single donation and include relevant donor and gift details.',
                'Constituents': 'Use this for contact exports from your CRM system. Each row should represent one individual. Households will be grouped based on the account ID in the next step.',
                'Other': 'Use this for miscellaneous datasets that don\'t fit other categories. This is helpful for integrating or enriching records across your CRM, email platform, or other systems.',
                'Email Contacts': 'Use this for exports from your email marketing platform. It should include email addresses, contact preferences, and engagement data such as opens and clicks.',
                'Activity Feed': 'Use this for any constituent engagement, such as volunteering, event attendance, or program participation. Include an account ID or contact ID for joining with constituent records.',
                'Direct Mail Select': 'Use this for lists of donors who received direct mail. Each row should include a unique donor ID and a matching key (e.g., appeal code) to associate with transactions.',
                'Email Send': 'Use this for records of marketing emails sent to constituents. Include the email address, send date, and relevant email metadata (e.g., campaign or subject line).',
                'Cost': 'This is a list of costs associated with a campaign or event. It should include the cost, the appeal code or UTM information to be matched with results.'
            };
            return descriptions[category];
        },
        arraysEqual(arr1, arr2) {
            if (arr1.length !== arr2.length) return false;
            arr1 = arr1.slice().sort();
            arr2 = arr2.slice().sort();
            for (let i = 0; i < arr1.length; i++) {
                if (arr1[i] !== arr2[i]) return false;
            }
            return true;
        },
        saveJoinBuilder(dataset){
            //Validate the join builder
            if(!this.$refs.join_builder[0].isValid())
                this.join_builder_form.error = true;

            else {
                this.join_builder_form.error = false;
                //if(this.filterHasChanged(dataset, index)){
                this.join_builder_form.busy = true;

                var num_processed = -1;
                for(let i = 0; i < dataset.joins.length; i++){
                    let join = dataset.joins[i];
                    let pos = i;

                    for(let j = 0; j < join.join_on.length; j++){
                        if(typeof join.join_on[j].dest_column.column == 'object'){
                            join.join_on[j].dest_column.column = join.join_on[j].dest_column.column.value;
                        }
                    }

                    //It is new
                    if(join.id <= 0){
                        window.axios.post('/api/data_set_join/'+this.client.url, join).then(response => {
                            dataset.joins[pos] = response.data.data;
                            num_processed++;
                            if(num_processed == dataset.joins.length){
                                location.reload();
                            }
                        });
                    }
                    else
                        window.axios.put('/api/data_set_join/'+this.client.url+ '/' + join.id, join).then(response => {
                            num_processed++;
                            if(num_processed == dataset.joins.length){
                                location.reload();
                            }
                        });
                }

                Swal.fire({
                    title: "Your Joins are Ready!",
                    text: "The new data is now available to be mapped in the sections above. The screen will refresh momentarily before you can proceed with mapping.",
                    icon: "success",
                    customClass: {
                        popup: 'swal-success'
                    },
                }).then((result) => {
                    num_processed++;
                    if(num_processed == dataset.joins.length){
                        location.reload();
                    }
                });

                this.join_builder_form.busy = false;
                this.closeAllAccordions();
                this.$forceUpdate();
            }
        },
        saveInclusionFilters(dataset, index){
            //Validate the query builder
            if(!this.$refs.filter[0].isFormValid())
                this.inclusion_filter_form.error = true;

            else {
                this.inclusion_filter_form.error = false;
                //if(this.filterHasChanged(dataset, index)){
                this.inclusion_filter_form.busy = true;
                //Make a deep copy of the dataset so that I can remove the columns to prevent them from being saved
                dataset = JSON.parse(JSON.stringify(dataset));
                //Unset the columns
                dataset.columns = null;
                dataset.update_type = 'filter';

                window.axios.put('/api/data_set/'+this.client.url+ '/' + dataset.id, dataset).then(response => {
                    // preserve the dest_columns, it is not part of the response data
                    let dest_columns = this.local_datasets[index].dest_columns;

                    this.local_datasets[index] = {
                        ...response.data.data,
                        dest_columns: dest_columns ? [...dest_columns] : []
                    };
                    this.constructDestColumnArray();
                    this.inclusion_filter_form.busy = false;
                    this.showNotification({
                        text: 'Your inclusion filters were successfully saved! Your data will begin reprocessing shortly.'
                    });
                    this.closeAllAccordions();
                    this.$forceUpdate();


                }).catch(error => {
                    this.showNotification({
                        text: 'Error saving the data set! ' + (error.response?.data?.message || 'Please try again.'),
                        type: 'error'
                    });
                });
            }
        },
        filterHasChanged(updated_dataset, index) {
            var saved_dataset = (this.file_or_connection == 'connection'? this.selected_connection_or_file.datasets[index]: this.selected_connection_or_file.dataset);
            return !this.deepEqual(saved_dataset.filter, updated_dataset.filter);
        },
        deepEqual(obj1, obj2){
            if (obj1 === obj2) return true;

            if (typeof obj1 !== 'object' || obj1 === null ||
                typeof obj2 !== 'object' || obj2 === null) {
                return false;
            }

            let keys1 = Object.keys(obj1);
            let keys2 = Object.keys(obj2);

            if (keys1.length !== keys2.length) return false;

            for (let key of keys1) {
                if (!keys2.includes(key) || !this.deepEqual(obj1[key], obj2[key])) {
                    return false;
                }
            }

            return true;
        },
        saveColumnMapping(dataset, index){
            this.column_mapping_form.error = false;

            //Validate the query builder
            if(!this.$refs.column_mapping[0].isValid())
                this.column_mapping_form.error = true;
            else if(!this.columnsValid()){
                this.column_mapping_form.error = true;
                Swal.fire({
                    title: "Error",
                    html: "The columns that you utilized in your column mapping aren't available with all of the matching files. Please delete the files noted in the table or remove the new mappings not present in those files.",
                    icon: "error",
                    customClass: {
                        popup: 'swal-error'
                    },
                });
            }
            else {
                this.column_mapping_form.busy = true;
                dataset.update_type = 'column_mapping';
                // Store the segments before the API call
                const currentSegments = dataset.segments ? [...dataset.segments] : [];

                var cleaned_columns = dataset.columns ? [...dataset.columns] : [];
                cleaned_columns.forEach(column => {
                    column.data_set_id = dataset.id;
                    if (column.source_column == "CUSTOM") {
                        if (column.column_logic && column.column_logic.default_value 
                            && typeof column.column_logic.default_value == 'object') {
                            column.column_logic.default_value = column.column_logic.default_value.value;
                        }
                        for (let i = 0; i < column.column_logic.units.length; i++) {
                            if (column.column_logic.units[i] && column.column_logic.units[i].value 
                                && typeof column.column_logic.units[i].value == 'object') {
                                column.column_logic.units[i].value = column.column_logic.units[i].value.value;
                            }

                            for (let j = 0; j < column.column_logic.units[i].logic.length; j++) {
                                if (column.column_logic.units[i].logic[j] && column.column_logic.units[i].logic[j].value 
                                    && typeof column.column_logic.units[i].logic[j].value == 'object') {
                                    column.column_logic.units[i].logic[j].value = column.column_logic.units[i].logic[j].value.value;
                                }
                            }
                        }
                    }
                });
                // Create a deep copy of the dataset with columns
                const datasetToSave = {
                    ...dataset,
                    columns: cleaned_columns,
                };

                window.axios.put('/api/data_set/'+this.client.url + '/' + dataset.id, datasetToSave)
                    .then(response => {
                        // Get the response data
                        const responseData = response.data.data;

                        // Ensure segments are preserved
                        if (!responseData.segments || responseData.segments.length === 0) {
                            responseData.segments = currentSegments;
                        }

                        // preserve the dest_columns, it is not part of the response data
                        let dest_columns = this.local_datasets[index].dest_columns;

                        // Update the local dataset with the response data
                        this.local_datasets[index] = {
                            ...responseData,
                            columns: responseData.columns ? [...responseData.columns] : [],
                            dest_columns: dest_columns ? [...dest_columns] : []
                        };

                        this.constructDestColumnArray();

                        // after updating this.local_datasets[index] …
                        if (this.file_or_connection === 'connection') {
                        const pIdx = this.selected_connection_or_file.datasets
                                        .findIndex(ds => ds.id === this.local_datasets[index].id);
                        if (pIdx !== -1) {
                            this.selected_connection_or_file.datasets.splice(
                            pIdx, 1, { ...this.local_datasets[index] });
                        }
                        } else if (this.file_or_connection === 'file') {
                        this.selected_connection_or_file.dataset = { ...this.local_datasets[0] };
                        }
                        
                        this.column_mapping_form.busy = false;

                        // Mark the column mapping component as saved to prevent cleanup of temporary column definitions
                        if (this.$refs.column_mapping && this.$refs.column_mapping[0] && typeof this.$refs.column_mapping[0].markAsSaved === 'function') {
                            this.$refs.column_mapping[0].markAsSaved();
                        }

                        this.showNotification({
                            text: 'Your column mappings were successfully saved! Your data will begin reprocessing shortly; you\'ll be notified when it\'s complete.'
                        });

                        // Force update to ensure the segments count is displayed correctly
                        this.$nextTick(() => {
                            this.closeAllAccordions();
                            this.$forceUpdate();
                        });
                }).catch(error => {
                    // Reset the busy state to reactivate the save button
                    this.column_mapping_form.busy = false;
                    
                    this.showNotification({
                        text: 'Error saving the data set! ' + (error.response?.data?.message || 'Please try again.'),
                        type: 'error'
                    });
                });
            }
        },
        deleteSegment(seg, dataset_index, segment_index) {
            //Show a warning
            Swal.fire({
              title: "Are you sure you want to delete this audience?",
              text: "The audience will no longer be available for data analysis and any connections with 3rd party systems will also be removed.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes, delete",
              customClass: {
                popup: 'swal-warning'
              },
            }).then((result) => {
                if (result.isConfirmed) {
                    window.axios.delete('/api/audience/'+this.client.url + '/' + seg.id)
                    .then(response => {
                        const segmentName = seg.name || 'Your segment';
                        this.showNotification({
                            text: '<strong>' + segmentName + '</strong> has been deleted!'
                        });
                        this.local_datasets[dataset_index].segments.splice(segment_index, 1);
                        
                        this.$forceUpdate();
                    });
                }
            });
        },
        deleteConnection() {

            Swal.fire({
              title: "Are you sure you want to delete this connection?",
              text: "Deleting the connection will remove the connection and all associated data.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes, delete",
              customClass: {
                popup: 'swal-warning'
              },
            }).then((result) => {
              if (result.isConfirmed) {
                window.axios.delete('/api/connection/' + this.local_connection.id).then(response => {
                    //Find the connection in the local_connections
                    const connectionName = this.local_connection.name || 'Your connection';
                    this.showNotification({
                        text: '<strong>' + connectionName + '</strong> has been deleted!'
                    });
                    this.$emit('delete-connection', this.local_connection)
                }).catch(error => {
                    const connectionName = this.local_connection.name || 'Your connection';
                    this.showNotification({
                        text: 'Failed to delete <strong>' + connectionName + '</strong>. Please try again.',
                        type: 'error'
                    });
                });
            }
            });
        },
        syncConnection() {
            window.axios.get('/api/connection/' + this.local_connection.id + '/refresh').then(response => {
                //This will change the status
                this.local_connection.active_jobs = ["something"];
                this.local_connection.sync_error_msg = null; // Clear error message when starting a sync
                this.$forceUpdate();

                this.showNotification({
                    text: 'Success! Your connection will begin refreshing momentarily.'
                });
            }).catch(error => {
                // Handle errors here
                this.showNotification({
                    text: 'Error syncing connection. ' + (error.response?.data?.message || 'Please try again.'),
                    type: 'error'
                });
            });
        },
        updateConnection(){
            this.connection_selected = this.local_connection;
            this.$nextTick(() => {
                const modalElement = document.getElementById('system-modal');
                if (modalElement) {
                    const modal = new bootstrap.Modal(modalElement);
                    modal.show();
                }
            });
        },
        isDataFile(file) {
            // If the file type is a csv, tab, tsv, or txt
            return file.status == 'ready' && ['csv', 'tsv', 'tab', 'txt'].includes(file.type);
        },
        previewTable(file) {
            var self = this;
            this.current_file = file;
            this.table_data = "";

            window.axios.post('/api/bigquery/get_detailed_samples', {'data_source': 'file', 'data_source_id': file.id }).then(response => {
                if(response.status == 200) {
                    self.table_data = response.data.samples;
                }
                else
                    self.table_data = response.data.error;
              });
        },
        closePreviewModal() {
            var myModalEl = document.getElementById('preview-modal')
            var modal = bootstrap.Modal.getInstance(myModalEl)
            modal.hide();
        },
        originalHeader(value) {
            //Do a foreach loop through this.current_file.columns with a key/val
            for (var key in this.current_file.columns) {
                if(key == value)
                    return this.current_file.columns[key];
            }
            return value;
        },
        withinThirtyDays(file) {
            //If the file.created_at is within the last 30 days
            return moment().subtract(30, 'days').isBefore(file.created_at) && file.gcs_processed_path != null;
        },
        removeFile(file) {
            var self  = this;
            Swal.fire({
              title: "Are you sure you want to delete <em>" + file.name + "</em>?",
              text: "This will remove the file from the system and prevent it from being used with future data processes.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes, delete",
              customClass: {
                popup: 'swal-warning'
              },
            }).then((result) => {
                if (result.isConfirmed) {
                    window.axios.delete('/api/files/' + self.client.url + '/destroy/' + file.id)
                        .then(response => {
                            window.location = '/settings/' + this.client.url + '/files';
                        });
                }
            });
        },
        openSupportModal(){
            this.selected_ticket_type='SETUP_HELP';
            // var modal = new bootstrap.Modal(document.getElementById('support-modal-'+this.selected_ticket_type));
            // modal.show();
        },
        resetModal(){
            this.connection_selected = null;
        },
        updateColumns(newColumns, index) {
            this.local_datasets[index].columns = newColumns;
            this.$forceUpdate();
        },
        getLastSync(conn_id) {
            let lastSync = null;
            let lastFailedSync = null;
            let mostRecentDate = null;

            // Check if local_connection has census_connections
            if (this.local_connection && this.local_connection.id === conn_id && this.local_connection.census_connections) {
                for(var j = 0; j < this.local_connection.census_connections.length; j++) {
                    const census_conn = this.local_connection.census_connections[j];
                    if(census_conn.syncs && census_conn.syncs.length > 0) {
                        // Check each sync
                        for(var k = 0; k < census_conn.syncs.length; k++) {
                            const sync = census_conn.syncs[k];
                            
                            // If this sync failed, keep track of it
                            if(sync.last_sync_status === 'failed') {
                                if(!lastFailedSync || new Date(sync.last_synced_at) > new Date(lastFailedSync.last_synced_at)) {
                                    lastFailedSync = sync;
                                }
                            }
                            
                            // Keep track of most recent sync
                            if(!mostRecentDate || new Date(sync.last_synced_at) > mostRecentDate) {
                                mostRecentDate = new Date(sync.last_synced_at);
                                lastSync = sync;
                            }
                        }
                    }
                }
            }

            // Return failed sync if one exists, otherwise return most recent
            return lastFailedSync || lastSync;
        },
        getLastSyncStatus(conn_id) {
            var last_sync = this.getLastSync(conn_id);
            if(last_sync != null)
                return last_sync.last_sync_status;
            return null;
        },
        getLastSyncErrorMessage(conn_id) {
            var last_sync = this.getLastSync(conn_id);
            if(last_sync != null)
                return '<strong>Pathway Error:</strong> ' + last_sync.last_sync_error_message;
            return null;
        },
        requestFilterSuggestion(dataset, index) {
            // Always prompt for user context before requesting filter suggestion
            Swal.fire({
                title: 'Refine Filter',
                html: `
                    <p class="mb-2">What information do you want to include or exclude from this data set?</p>
                    <textarea id="filter-context" class="form-control" placeholder="E.g., Exclude non-gift transaction types; Only include active constituents; etc." style="width: 100%; min-height: 100px;"></textarea>
                `,
                showCancelButton: true,
                confirmButtonText: 'Submit',
                cancelButtonText: 'Cancel',
                preConfirm: () => {
                    const context = document.getElementById('filter-context').value;
                    return context || null;
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    const userContext = result.value || '';
                    
                    // Disable the button for this dataset - it will be re-enabled when notification arrives or on error
                    this.filterSuggestionDisabled[index] = true;

                    // Request AI filter suggestion
                    window.axios.post(`/api/filter-mapping/${this.client.url}/suggest`, {
                        data_set_id: dataset.id,
                        user_context: userContext,
                        current_filter: dataset.filter, // Send current filter as context
                    }).then(() => {
                        this.showNotification({
                            icon: '/img/icons/nav-icons/Edna.svg',
                            text: 'We are analyzing your data set to suggest a filter. You\'ll be notified when it\'s ready!',
                            type: 'info'
                        });
                        
                        // Start polling as fallback for missed Echo events
                        const requestKey = `filter-dataset-${dataset.id}`;
                        this.startPolling({
                            requestKey,
                            checkFn: createDataSetFilterCheckFunction({
                                clientUrl: this.client.url,
                                dataSetId: dataset.id
                            }),
                            onSuccess: (data) => {
                                this.filterSuggestionDisabled[index] = false;
                                if (data && data.proposal) {
                                    // Show notification that polling detected the update
                                    this.showNotification({
                                        icon: '/img/icons/nav-icons/Edna.svg',
                                        text: 'Avid has a filter suggestion for you to review. Click here to review.',
                                        type: 'success',
                                        action: {
                                            type: 'openFilterProposal',
                                            data_set_id: dataset.id,
                                            proposal: data.proposal,
                                            reasoning: data.reasoning,
                                            previous_response_id: data.response_id
                                        }
                                    });
                                }
                            },
                            onTimeout: () => {
                                this.filterSuggestionDisabled[index] = false;
                            },
                            onNoResult: () => {
                                this.filterSuggestionDisabled[index] = false;
                                this.showNotification({
                                    icon: '/img/icons/avid-icons/danger.svg',
                                    text: 'The AI suggestion completed but no changes were detected. Please try again.',
                                    type: 'error'
                                });
                            }
                        });
                    }).catch(error => {
                        console.error('Error requesting filter suggestion:', error);
                        this.showNotification({
                            text: error.response?.data?.message || 'Failed to request filter suggestion. Please try again.',
                            type: 'error'
                        });
                        
                        // Re-enable the button on error
                        this.filterSuggestionDisabled[index] = false;
                    });
                }
            });
        },
        handleOpenFilterProposalEvent(event) {
            const actionData = event.detail;
            if (actionData && actionData.type === 'openFilterProposal' && actionData.data_set_id) {
                // Stop polling since we received the event
                const requestKey = `filter-dataset-${actionData.data_set_id}`;
                if (this.stopPolling) {
                    this.stopPolling(requestKey);
                }
                
                // Find the dataset index and re-enable the Refine button
                const datasetIndex = this.local_datasets.findIndex(ds => ds.id === actionData.data_set_id);
                if (datasetIndex !== -1) {
                    this.filterSuggestionDisabled[datasetIndex] = false;
                }
                
                // Open the modal directly
                this.handleOpenFilterProposalModal(actionData.data_set_id);
            }
        },
        handleOpenFilterProposalModal(dataSetId) {
            // console.log('ConnectionsSettingsViewDataset: Opening filter proposal modal', {
            //     dataSetId,
            //     availableRefs: Object.keys(this.$refs).filter(k => k.startsWith('filterProposalModal')),
            //     localDatasets: this.local_datasets.map(ds => ({ id: ds.id, name: ds.name })),
            // });
            
            // Find the modal ref and show it
            // With v-for, refs are stored as arrays
            const refKey = 'filterProposalModal' + dataSetId;
            const modalRef = this.$refs[refKey];
            
            const modal = Array.isArray(modalRef) && modalRef.length > 0 ? modalRef[0] : modalRef;
            
            if (modal && typeof modal.show === 'function') {
                // Force reload by resetting hasLoaded if the modal has a method to do so
                // The show() method will handle reloading for dataset-based modals
                modal.show();
            } else {
                console.error('ConnectionsSettingsViewDataset: Could not find modal ref', {
                    refKey,
                    availableRefs: Object.keys(this.$refs),
                });
            }
        },
        handleFilterProposalAccepted(data) {
            // Stop polling since proposal was accepted
            if (data.data_set_id && this.stopPolling) {
                const requestKey = `filter-dataset-${data.data_set_id}`;
                this.stopPolling(requestKey);
            }
            
            // Update the dataset filter
            const index = this.local_datasets.findIndex(ds => ds.id === data.data_set_id);
            if (index !== -1) {
                this.local_datasets[index].filter = data.filter;
                this.$forceUpdate();
                
                this.showNotification({
                    icon: '/img/icons/nav-icons/Edna.svg',
                    text: 'Filter suggestion accepted and applied.',
                    type: 'success'
                });
            }
        },
        handleReEnableSuggestion(event) {
            const actionData = event.detail;
            // Handle filter suggestion re-enable for datasets
            if (actionData && actionData.data_set_id && !actionData.column_mapping_id) {
                const datasetIndex = this.local_datasets.findIndex(ds => ds.id === actionData.data_set_id);
                if (datasetIndex !== -1) {
                    this.filterSuggestionDisabled[datasetIndex] = false;
                }
            }
        },
    },
    beforeUnmount() {
        // Clean up event listeners
        window.removeEventListener('openFilterProposal', this.handleOpenFilterProposalEvent);
        window.removeEventListener('reEnableSuggestion', this.handleReEnableSuggestion);
    },
})
</script>
